import { RouteStop } from "./RouteStop"

export class DeliveryRouteOption {
  key: string

  name: string

  description: string

  stops: RouteStop[]

  totalDistanceKm: number

  estimatedDurationMinutes: number

  estimatedFuelCost: number

  estimatedEarnings: number

  isRecommended: boolean

  constructor(data: Partial<DeliveryRouteOption> = {}) {
    this.key = data.key ?? ""

    this.name = data.name ?? ""

    this.description = data.description ?? ""

    this.stops = (data.stops ?? []).map((e) => new RouteStop(e))

    this.totalDistanceKm = Number(data.totalDistanceKm ?? 0)

    this.estimatedDurationMinutes = data.estimatedDurationMinutes ?? 0

    this.estimatedFuelCost = Number(data.estimatedFuelCost ?? 0)

    this.estimatedEarnings = Number(data.estimatedEarnings ?? 0)

    this.isRecommended = data.isRecommended ?? false
  }
}
